import cx from 'classnames';
import {ReactNode} from 'react';
import {Link} from 'react-router-dom';

import './style.scss';

type Props = {
    title: string;
    link?: {
        path: string,
        name: string,
        description?: string,
        descriptionPage?: string
    }
    highlight?: boolean;
    titlePosition?: 'before' | 'after';
    children: ReactNode;
}

export const UnauthorizedLayoutContent: React.FC<Props> = ({title, highlight = true, titlePosition = 'before', link, children}: Props) => (
    <main className={
        cx('vs-unauthorized-layout-content tw-py-8 tw-px-8 sm:tw-px-16',
            'tw-text-default-dimmed tw-flex tw-flex-col tw-justify-center tw-self-center',
            {'sm:tw-shadow-lg sm:tw-bg-light': highlight})
    }
    >
        <h1 className={
            cx('tw-text-center tw-text-3xl tw-text-default-dimmed',
                {'tw-order-1 tw-mt-10': titlePosition === 'after', 'tw-mb-10': titlePosition === 'before'})
        }
        >
            {title}
        </h1>
        {children}
        {link && (
            <div className='tw-mt-12 tw-text-center'>
                {link.description}
                <Link to={link.path} className='tw-text-primary tw-underline tw-whitespace-nowrap'>
                    {link.name}
                </Link>
                {link.descriptionPage}
            </div>
        )}
    </main>
);